import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-custom-string-dialog',
  templateUrl: './custom-string-dialog.component.html',
  styleUrls: ['./custom-string-dialog.component.scss']
})
export class CustomStringDialogComponent {
  public title: string;
  public originalString: string;
  public customString: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CustomStringDialogComponent>
  ) {
    this.title = data.title;
    this.originalString = data.originalString;
    this.customString = data.customString;
  }

  updateCustomString(customString?: string) {
    this.dialogRef.close({
      action: 'update', value:
        customString != undefined ? customString : this.customString
    });
  }

  removeCustomString() {
    this.dialogRef.close({action: 'remove'});
  }

  close() {
    this.dialogRef.close();
  }
}
